import { useEffect, useState } from "react";
import { getPreviewToken } from "../lib/previewAuth";

// Preview-mode toggle. Draft Perspectives are gated server-side by a preview
// token — the token is provided once through the /preview gate and stored
// (session-scoped) in sessionStorage. This hook simply reports whether the
// current tab is inside an authorised preview session so components can show
// draft affordances (banners, badges, draft entries) and attach the preview
// header on requests.
//
// The legacy ?preview=perspectives URL flag is honoured for backwards
// compatibility — it still enables the visual affordances — but on its own
// it will not surface drafts because the API rejects unauthenticated
// draft access.
const KEY = "ttl101_preview_perspectives";

const readInitial = () => {
  try {
    const url = new URL(window.location.href);
    const q = url.searchParams.get("preview");
    if (q === "off") {
      sessionStorage.removeItem(KEY);
      sessionStorage.removeItem("ttl101_preview_token");
      return false;
    }
    if (q === "perspectives" || q === "1") {
      sessionStorage.setItem(KEY, "1");
      return true;
    }
    if (getPreviewToken()) return true;
    return sessionStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
};

export const usePreviewMode = () => {
  const [enabled, setEnabled] = useState(() => {
    try { return readInitial(); } catch { return false; }
  });
  useEffect(() => { setEnabled(readInitial()); }, []);
  return enabled;
};
